import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase().trim()

export class RecursoshumanosReportesRetencionInfonavitComponent {
  constructor (RecursoshumanosOperadorasService, RecursoshumanosReportesRetencionInfonavitService) {
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursoshumanosReportesRetencionInfonavitService = RecursoshumanosReportesRetencionInfonavitService
    this.operadora_id = null
    this.descarga = null
    this.inicio = null
    this.final = null
    this.filtro = ''
  }

  $onInit () {
    this.promise = this.RecursoshumanosOperadorasService.get()
      .then((response) => (this.operadoras = orderBy(response.data, ['nombre'])))
  }

  buscar () {
    this.RecursoshumanosReportesRetencionInfonavitService.get(this.operadora_id, this.inicio, this.final)
      .then((response) => {
        this.data = orderBy(response.data, ['nombre'])
        this.resultados = [...this.data]
      })
      .catch((response) => (console.error(response)))
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => normalizar(item.nombre.indexOf(filtro)) >= 0)
  }

  exportarXLS () {
    this.operadora = this.operadoras.find((item) => item.id_empresa === this.operadora_id)
    if (this.operadora) this.operadora = this.operadora.nombre
    else this.operadora = ''
    this.descarga = true
  }
}

module.component('recursoshumanosReportesRetencionInfonavit', {
  controller: RecursoshumanosReportesRetencionInfonavitComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/reportes/retencion/infonavit/component.js